<div>
  <button class="wrapperButton" (click)="requestLarger()" style="width:100%;">
    <img [src]="document.url" [alt]="altText" style="width:100%; max-height: 250px; padding-top: 5px; object-fit: contain;">
  </button>
</div>
